export default "/0a304cb652886471dc76c128ffb42505.jpg";